import { GEDDocumento } from "../../models/ged_documento";
import { IGetAllGedDocumentoUseCase } from "../../../presentation/useCases/read/get_all_ged_documento_use_case";
import { ICommonsRepository } from "../../repositories/commons_repository";
import { BasePaginatedUseCase } from "../base_paginated_use_case";
import { telaIdsToNumber, TelasIds } from "../../../utils/tela_ids";

export class GetAllGedDocumentoUseCase extends BasePaginatedUseCase<GEDDocumento> implements IGetAllGedDocumentoUseCase {
  constructor(private readonly repository: ICommonsRepository) {
    super();
  }

  async getAllGedDocumento(
    telaId: TelasIds,
    idModuloDocumento: number,
    tipoPesquisa: number | null,
    valueField: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllGedDocumento(
      telaIdsToNumber(telaId),
      idModuloDocumento,
      tipoPesquisa,
      valueField,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
